import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '/api';

function LoginForm({ onLogin }) {
  const [isRegister, setIsRegister] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const endpoint = isRegister ? '/register' : '/login';
      const body = isRegister ? { email, password, name, phone } : { email, password };

      const response = await fetch(API_URL + endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Ошибка');

      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      onLogin(data.user);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow-2xl p-8 border border-slate-200">
      <h2 className="text-2xl font-bold text-slate-800 mb-6 text-center">
        {isRegister ? 'Регистрация' : 'Вход в аккаунт'}
      </h2>

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg p-3 mb-4 text-sm">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        {isRegister && (
          <>
            <div className="mb-4">
              <label className="block text-sm text-slate-600 mb-2 font-medium">Имя</label>
              <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Ваше имя" required />
            </div>
            <div className="mb-4">
              <label className="block text-sm text-slate-600 mb-2 font-medium">Телефон</label>
              <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+7XXXXXXXXXX" required />
            </div>
          </>
        )}

        <div className="mb-4">
          <label className="block text-sm text-slate-600 mb-2 font-medium">Email</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email@example.com" required />
        </div>

        <div className="mb-6">
          <label className="block text-sm text-slate-600 mb-2 font-medium">Пароль</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Пароль" required />
        </div>

        <button type="submit" disabled={loading} className="w-full bg-gold-500 hover:bg-gold-400 text-dark-900 font-bold py-3 rounded-xl transition disabled:opacity-50">
          {loading ? 'Загрузка...' : (isRegister ? 'Зарегистрироваться' : 'Войти')}
        </button>
      </form>

      <div className="text-center mt-6">
        <button type="button" onClick={() => setIsRegister(!isRegister)} className="text-gold-600 hover:text-gold-700 text-sm bg-transparent border-none cursor-pointer font-medium">
          {isRegister ? 'Уже есть аккаунт? Войти' : 'Нет аккаунта? Зарегистрироваться'}
        </button>
      </div>
    </div>
  );
}

export default LoginForm;
